import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e194617e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "keyword-table-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Move to Negative ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_keyword_group_table = _resolveComponent("keyword-group-table")!
  const _component_default_button = _resolveComponent("default-button")!
  const _component_keyword_form = _resolveComponent("keyword-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_keyword_group_table, {
        header: _ctx.groupHeader,
        items: _ctx.groups,
        loading: _ctx.groupKeywordLoading,
        "is-loaded": _ctx.groupKeywordLoaded,
        "selected-group-row": _ctx.selectedGroupRow,
        "modal-title": "Delete keyword group?",
        "modal-content": "Deleting this keyword group name will remove it permanently. This action cannot be undone.",
        onLoadMore: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('loadMoreGroups'))),
        onUpdateName: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('updateGroupName', $event))),
        onRemoveGroupItem: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('removeGroupItem', $event))),
        onSelectedGroupItem: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('selectedGroupItem', $event)))
      }, null, 8, ["header", "items", "loading", "is-loaded", "selected-group-row"])
    ]),
    _createVNode(_component_keyword_form, {
      "search-box-placeholder": "Search Keywords",
      keywords: _ctx.keywords,
      "selected-keywords": _ctx.selectedKeywords,
      "selected-language": _ctx.selectedLanguage,
      "is-loaded": _ctx.isLoaded,
      loading: _ctx.loading,
      onSetSelectedLanguage: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('setSelectedLanguage', $event))),
      onSearch: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('search', $event))),
      onRemoveKeyword: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('removeKeyword', $event))),
      onChangeMatchType: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('changeMatchType', $event))),
      onSetSelectedKeyword: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('setSelectedKeyword', $event))),
      onLoadMore: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('loadKeywords', $event)))
    }, {
      button: _withCtx(() => [
        _createVNode(_component_default_button, {
          class: "space move-button",
          color: "purple",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('moveToNegative')))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["keywords", "selected-keywords", "selected-language", "is-loaded", "loading"])
  ]))
}